<router-outlet></router-outlet>
<p-dialog id="spinner-panel" [(visible)]="AppComponent.displayLoading" [closeIcon]="false" [showHeader]="false"
[dismissableMask]="false" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
[style]="{width: '50vw'}">
<app-spinner></app-spinner>
</p-dialog>
